<div class="p-3">
  <div class="row pt-2">
    <div class="col-12">
      <div [innerHTML]="email | safeHtml"></div>
    </div>
  </div>
</div>
